export default __webpack_public_path__ + "static/media/productScreen.e3d634c1.png";